import { pandaSelf } from "../const/globalThis";
export var warn = function warn(msg) {
  var _window$__PANDA;
  if (typeof console !== 'undefined' && ((_window$__PANDA = window.__PANDA) === null || _window$__PANDA === void 0 ? void 0 : _window$__PANDA.logLevel) >= 2) {
    console.warn("[panda-log] Warn: " + msg);
  }
};
export var error = function error(msg) {
  var _window$__PANDA2;
  if (typeof console !== 'undefined' && ((_window$__PANDA2 = window.__PANDA) === null || _window$__PANDA2 === void 0 ? void 0 : _window$__PANDA2.logLevel) >= 1) {
    console.error("[panda-log] Error: " + msg);
  }
};
export var debugInfo = function debugInfo(msg) {
  if (typeof console !== 'undefined' && pandaSelf.debug) {
    console.error("[panda-log] Debug: " + msg);
  }
};
export var debugError = function debugError(msg) {
  if (typeof console !== 'undefined' && pandaSelf.debug) {
    console.error("[panda-log] Error:", msg);
  }
};
export var isDebugConsole = function isDebugConsole() {
  return typeof console !== 'undefined' && pandaSelf.debug;
};